import { AxiosResponse, AxiosStatic } from "axios";
import { IPatchPayload } from "../../components/course-author/helpers/patches";
import { ICreationResponse, IFullClass } from "../../parsers/resolve";

export interface IClassesApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export interface IClassesApi {
  create: (fullClass: IFullClass, accountId: string) => Promise<AxiosResponse<ICreationResponse<IFullClass>>>;
  getEditableByRelativeTo: (accountId: string, organizationId: string) => Promise<AxiosResponse>;
  patchClass: (accountId: string, classId: string, patch: IPatchPayload) => Promise<AxiosResponse>;
}

export default class ClassesApi implements IClassesApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: IClassesApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public getEditableByRelativeTo = (accountId: string, organizationId: string) => {
    return this.axios.get(
      `${this.apiRoot}/collections/classes/editableBy/${accountId}/relativeToOrg/${organizationId}`,
      {
        params: { activeUser: accountId },
      }
    );
  };

  public patchClass = (activeUser: string, classId: string, patch: IPatchPayload) =>
    this.axios.post(`${this.apiRoot}/classes/${classId}/_patches`, patch, {
      params: { activeUser },
    });

  public create = (fullClass: IFullClass, activeUser: string) =>
    this.axios.post(`${this.apiRoot}/classes`, fullClass, {
      params: { activeUser },
    });
}
